import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { BrandModel, BrandViewModel } from 'projects/Administration/src/app/business-entities/brand-view-model';
import { Features } from 'projects/Administration/src/app/business-entities/user-role-view-model';
import { BrandService } from 'projects/Administration/src/app/business-services/brand.service';
import { ImageService } from 'projects/Administration/src/app/services/image.service';
import { SecureStorage } from 'projects/Autofacets-Core/src/app/common-services/SecureStorage.service';
import * as Enums from 'projects/Autofacets-Core/src/app/utils/enums';

@Component({
  selector: 'app-edit-brand',
  templateUrl: './edit-brand.component.html',
  styleUrls: ['./edit-brand.component.css']
})
export class EditBrandComponent implements OnInit {

  brandModel: BrandViewModel;
  brandViewModel:BrandModel={
    brandCode:'',
    brandImageBinaryData:'',
    brandName:'',
    id:0,
    image:'',
    isActive:true,
    mimeType:'',
    size:0,
    IntegrationWithDMS:false,
    moduleId: Enums.ModuleNames.Brand
  };
  editBrand = false;
  editBrandForm: FormGroup;
  brandImageName: string = null;
  image:string | ArrayBuffer;
  imageBaseData: string | ArrayBuffer = null;
  mimeType:string = ''
  ImageBinaryData:string | ArrayBuffer = null
  imageName:string;
  isValidImg:boolean = true;
  features: Features[] = [];
  constructor(
    private brandService: BrandService,
    private router: Router,
    private formBuilder: FormBuilder,
    private spinner: NgxSpinnerService,
    private toaster: ToastrService,
    private translate: TranslateService,
    private activeModal : NgbActiveModal,
    private secureStorage : SecureStorage,
    private imageService:ImageService
  ) { }

  ngOnInit(): void {
    this.GetBrand(this.brandService.brandId)
    this.getFeatures();
  }
  async getFeatures(){
    this.features = this.secureStorage.getKeyData('feature');
  }
  private async GetBrand(Id: number) {
    this.spinner.show();
    await this.brandService.GetBrandById(Id).then(result => {
      if (result) {
        if(result.errorCount)
        {
          let errorMessage = this.translate.instant("lblBrandNotFound");
          this.toaster.error(errorMessage);
        }
        else{ this.brandModel = result}
        if (this.brandModel) {
          this.initializeForm();
          this.editBrandForm.patchValue({
            ...result,
          })
          this.ImageBinaryData = this.brandModel.image
        }
      }
      this.spinner.hide();
    },
    _error => {
        this.spinner.hide()
      });
  }
  get cpf() {
    return this.editBrandForm.controls;
  }
  initializeForm(): void {
    this.editBrandForm = this.formBuilder.group({
      brandCode: [{value: '', disabled: true},[Validators.required ,Validators.pattern(/^\S*$/)]],
      brandName: [{value: '', disabled: true},[Validators.required ,Validators.pattern(/^[^\s]+(\s+[^\s]+)*$/)]],
      image: [''],
      isActive: ['']
    });
  }
  onChangeFileUpload(files: FileList) {
    const me = this;
    const file = files[0];
    this.brandViewModel.mimeType = files[0].type;
    this.brandViewModel.image = files[0].name;
    this.brandViewModel.size = files[0].size;
    this.editBrandForm.controls['image'].setValue(files[0].name);
    let imgerrormsg = this.translate.instant("lblImageFormatError");
    this.imageName = file.name;
    const reader = new FileReader();
    reader.readAsDataURL(file);
    const isValidFormat=this.imageService.validateImageFormat(this.brandViewModel.mimeType);
    if(isValidFormat)
    {
    if(this.brandViewModel.size < 100000)
    {
    reader.onload = (_readerEvent) => {
      this.brandModel.image = "";
      me.imageBaseData = reader.result;
      this.brandViewModel.brandImageBinaryData = reader.result.toString().replace('data:' +  this.brandViewModel.mimeType  + ';base64,', '');
      this.ImageBinaryData = me.imageBaseData;
    };
    this.isValidImg = true;
    }
    else
    {
      this.isValidImg = false;
      let errormsg = this.translate.instant("lblSizeExceedError");
      this.toaster.error(errormsg);
    }
  }
    else {
      this.isValidImg = false;
      this.spinner.hide();
      this.toaster.error(imgerrormsg);
    }

    reader.onerror = function (_error) {
      // This is intentional
    };

  }

  EditBrand()
  {
    this.spinner.show();
    if (this.features && this.features.length > 0) {
      let feature = this.features.find(x => x.featureCode === Enums.FeatureCode.DMS)?.isActive
      this.brandViewModel.IntegrationWithDMS = feature;
    }
    this.brandViewModel.id = this.brandModel.id;
    this.brandViewModel.brandCode = this.editBrandForm.controls['brandCode'].value
    this.brandViewModel.brandName = this.editBrandForm.controls['brandName'].value
    this.brandViewModel.image = this.imageName
    let imgerrormsg = this.translate.instant("lblImageFormatError");
    this.brandViewModel.isActive = this.editBrandForm.controls['isActive'].value
      if (this.brandViewModel.image!==undefined)
      {
          const isValidFormat=this.imageService.validateImageFormat(this.brandViewModel.mimeType);
          if(isValidFormat)
          {
            this.UpdateBrand();
          }
        else
        {
            this.spinner.hide();
            this.toaster.error(imgerrormsg);
            return;
        }
      }
      else
      {
        this.UpdateBrand();
      }
    this.spinner.hide();
  }

  UpdateBrand()
  {
    let editMessage = this.translate.instant("lblBrandEdited");
    let internalErrorMessage = this.translate.instant("lblBrandEditInternalError");
    let alreadyAddedRentalCarMessage = this.translate.instant("lblBrandAlreadyAdded");
    this.brandService.EditBrand(this.brandViewModel).then(res => {
      if (res.responseCode === Enums.ErrorCodes.SuccessCode) {
        this.toaster.success(editMessage);
        this.spinner.hide();
        this.activeModal.close({ success: true });
      }
      else if (res.responseCode === Enums.ErrorCodes.InterrnalError) {
        this.spinner.hide();
        this.toaster.error(internalErrorMessage);
      }
      else if (res.responseObject === Enums.ErrorCodes.RentalCarAlreadyAdded) {
        this.spinner.hide();
        this.toaster.warning(alreadyAddedRentalCarMessage);
      }
    });
  }
  OnClose(){
    this.activeModal.close({success:false})
  }


}
